import React, { createContext, useContext, useReducer } from 'react'

import { User } from 'services/users'

interface State {
  loading: boolean
  users: User[]
  totalPage: number
  currentPage: number
  search: string
}

interface Action {
  type: string
  payload?: any
}

const initState: State = {
  loading: false,
  users: [],
  totalPage: 1,
  currentPage: 1,
  search: '',
}

const UserContext = createContext<any>(null)

function reducer(state: State, { type, payload }: Action) {
  switch (type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: payload,
      }
    case 'SET_USERS':
      return {
        ...state,
        loading: false,
        users: payload.data,
        totalPage: payload.meta.last_page,
      }
    case 'SET_SEARCH':
      return {
        ...state,
        search: payload,
        currentPage: 1,
      }
    case 'SET_CURRENT_PAGE':
      return {
        ...state,
        currentPage: payload,
      }
    default:
      return state
  }
}

const UserContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState)

  return (
    <UserContext.Provider value={{ ...state, dispatch }}>
      {children}
    </UserContext.Provider>
  )
}

const useUserContext = () => {
  return useContext(UserContext)
}

export { UserContextProvider as default, useUserContext }
